<form autocomplete="off" class="p-0" novalidate [formGroup]="admissionDetailsForm">
    <div class="col-lg-12 col-md-12">
            <div class="mt-3">
            <div>
                <h3 class="main-content-label mb-2"><b>
                        <img alt="Logo" width="20vh" src="../../assets/images/school.png" class="mh-45px mrl mt-1 pb-2">
                        Addmission Details</b></h3>
            </div>
            <div class="row clearfix">
                <div class="col-sm-2" *ngIf="admissionDetailsFormArray['StuStyMode'][0]['FormVisible']">
                    <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>{{admissionDetailsFormArray['StuStyMode'][0]['FormDisplayName']}}
                                <span *ngIf="admissionDetailsFormArray['StuStyMode'][0]['FormRequired']">*</span>
                            </mat-label>
                            <mat-select #select31 class="colorblack" formControlName="StuStyMode">
                                <mat-select-filter *ngIf="select31.focused" [placeholder]="'Filter'"
                                    [displayMember]="'CdCode'" [array]="studyModeList"
                                    (filteredReturn)="filteredstudyModeList =$event"></mat-select-filter>
                                <mat-option *ngFor="let item of filteredstudyModeList" [value]="item.CdCode">
                                    {{item.CdDesc}}
                                </mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="admissionDetailsForm.controls['StuStyMode'].touched && admissionDetailsForm.controls['StuStyMode'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
              
                <div class="col-sm-2" *ngIf="admissionDetailsFormArray['StuType'][0]['FormVisible']">
                    <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>{{admissionDetailsFormArray['StuType'][0]['FormDisplayName']}}
                                <span *ngIf="admissionDetailsFormArray['StuType'][0]['FormRequired']">*</span>
                            </mat-label>
                            <mat-select #select32 class="colorblack" formControlName="StuType">
                                <mat-select-filter *ngIf="select32.focused" [placeholder]="'Filter'"
                                    [displayMember]="'CdCode'" [array]="sTypeList"
                                    (filteredReturn)="filteredsTypeList =$event"></mat-select-filter>
                                <mat-option *ngFor="let item of filteredsTypeList" [value]="item.CdCode">
                                    {{item.CdDesc}}
                                </mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="admissionDetailsForm.controls['StuType'].touched && admissionDetailsForm.controls['StuType'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="admissionDetailsFormArray['Session'][0]['FormVisible']">
                    <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>{{admissionDetailsFormArray['Session'][0]['FormDisplayName']}}
                                <span *ngIf="admissionDetailsFormArray['Session'][0]['FormRequired']">*</span>
                            </mat-label>
                            <mat-select  #select232 placeholder="Session" class="colorblack"
                              formControlName="Session" >
                              <mat-select-filter *ngIf="select232.focused" [placeholder]="'Filter'"
                                [displayMember]="'SnName'" [array]="sessionList"
                                (filteredReturn)="SessionFilterList =$event"></mat-select-filter>
                              <mat-option *ngFor="let item of SessionFilterList" [value]="item.SnNo">
                                {{item.SnName}}
                              </mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                              *ngIf="admissionDetailsForm.controls['Session'].touched && admissionDetailsForm.controls['Session'].errors?.required">
                              Mandatory
                            </mat-error>
                          </mat-form-field>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="admissionDetailsFormArray['StuFacId'][0]['FormVisible']">
                    <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>{{admissionDetailsFormArray['StuFacId'][0]['FormDisplayName']}}
                                <span *ngIf="admissionDetailsFormArray['StuFacId'][0]['FormRequired']">*</span>
                            </mat-label>
                            <mat-select disabled #select33 placeholder="FcCode" class="colorblack" formControlName="StuFacId">
                                <mat-select-filter *ngIf="select33.focused" [placeholder]="'Filter'"
                                    [displayMember]="'FcDesc'" [array]="facultyList"
                                    (filteredReturn)=" filteredFacultyList =$event"></mat-select-filter>
                                <mat-option *ngFor="let item of  filteredFacultyList" [value]="item.FcCode"
                                    (click)="getCourseData(item.FcCode)">
                                    {{item.FcDesc}}
                                </mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="admissionDetailsForm.controls['StuFacId'].touched && admissionDetailsForm.controls['StuFacId'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>

                    </div>
                </div>
                <div class="col-sm-3" *ngIf="admissionDetailsFormArray['StuCoId'][0]['FormVisible']">
                    <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label> {{admissionDetailsFormArray['StuCoId'][0]['FormDisplayName']}}
                                <span *ngIf="admissionDetailsFormArray['StuCoId'][0]['FormRequired']">*</span>
                            </mat-label>
                            <mat-select disabled #select34 placeholder="CoCode" class="colorblack" formControlName="StuCoId">
                                <mat-select-filter *ngIf="select34.focused" [placeholder]="'Filter'"
                                    [displayMember]="'CoName'" [array]="courseList"
                                    (filteredReturn)=" filteredCourseList =$event"></mat-select-filter>
                                <mat-option *ngFor="let item of filteredCourseList" [value]="item.CoCode"
                                    (onSelectionChange)="getExamStreamData(item.CoCode)">
                                    {{item.CoName}}
                                </mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="admissionDetailsForm.controls['StuCoId'].touched && admissionDetailsForm.controls['StuCoId'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="admissionDetailsFormArray['StuEmId'][0]['FormVisible']">
                    <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>{{admissionDetailsFormArray['StuEmId'][0]['FormDisplayName']}}
                                <span *ngIf="admissionDetailsFormArray['StuEmId'][0]['FormRequired']">*</span>
                            </mat-label>
                            <mat-select #select36 class="colorblack" formControlName="StuEmId">
                                <mat-select-filter *ngIf="select36.focused" [placeholder]="'Filter'"
                                    [displayMember]="'EmName'" [array]="examList"
                                    (filteredReturn)=" filteredExamList =$event"></mat-select-filter>
                                <mat-option *ngFor="let item of  filteredExamList" [value]="item.EmId"
                                    (onSelectionChange)="getSubData(item)" (click)="ChangeStudyMode(item)">
                                    {{item.EmName}}
                                </mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="admissionDetailsForm.controls['StuEmId'].touched && admissionDetailsForm.controls['StuEmId'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="col-sm-2" *ngIf="BranchShow">
                    <div class="form-group" *ngIf="admissionDetailsFormArray['StuBrId'][0]['FormVisible']">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>{{admissionDetailsFormArray['StuBrId'][0]['FormDisplayName']}}
                                <span *ngIf="admissionDetailsFormArray['StuBrId'][0]['FormRequired']">*</span>
                            </mat-label>
                            <mat-select #select35 placeholder="StrName" class="colorblack" formControlName="StuBrId">
                                <mat-select-filter *ngIf="select35.focused" [placeholder]="'Filter'"
                                    [displayMember]="'StrName'" [array]="courseStreamList"
                                    (filteredReturn)=" filteredStreamList =$event"></mat-select-filter>
                                <mat-option *ngFor="let item of  filteredStreamList" [value]="item.StrId"
                                    (onSelectionChange)="getSubDatawithBranch(item)">
                                    {{item.StrName}}
                                </mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="admissionDetailsForm.controls['StuBrId'].touched && admissionDetailsForm.controls['StuBrId'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-sm-2 hidden">
                     <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>{{admissionDetailsFormArray['StuSubjectRg'][0]['FormDisplayName']}}
                                <span *ngIf="admissionDetailsFormArray['StuSubjectRg'][0]['FormRequired']">*</span>
                            </mat-label>
                            <mat-select #select37 class="colorblack" multiple formControlName="StuSubjectRg"
                                (selectionChange)="onSelectionChange($event)">
                                <mat-select-filter *ngIf="select37.focused" [placeholder]="'Filter'"
                                    [displayMember]="'EsName'" [array]="subList"
                                    (filteredReturn)=" filteredSubList =$event"></mat-select-filter>
                                <mat-option *ngFor="let item of  filteredSubList" [value]="item.EsCode">
                                    {{item.EsName}}
                                </mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="admissionDetailsForm.controls['StuSubjectRg'].touched && admissionDetailsForm.controls['StuSubjectRg'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="admissionDetailsFormArray['StuCgId'][0]['FormVisible']">
                    <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>{{admissionDetailsFormArray['StuCgId'][0]['FormDisplayName']}}
                                <span *ngIf="admissionDetailsFormArray['StuCgId'][0]['FormRequired']">*</span>
                            </mat-label>
                              <mat-select disabled #select38 class="colorblack" formControlName="StuCgId">
                                <mat-select-filter *ngIf="select38.focused" [placeholder]="'Filter'"
                                    [displayMember]="'CgName'" [array]="stucourseClgMapList"
                                    (filteredReturn)=" filteredstucourseClgMapListList =$event"></mat-select-filter>
                                <mat-option *ngFor="let item of  filteredstucourseClgMapListList" [value]="item.CgCode"
                                    (click)="scrutenylevelCheck(item)" (click)="cutoff(item.CgCode)">
                                    {{item.CgName}}
                                </mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="admissionDetailsForm.controls['StuCgId'].touched && admissionDetailsForm.controls['StuCgId'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-sm-3" *ngIf="admissionDetailsFormArray['StuExamCenter'][0]['FormVisible']">
                    <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>{{admissionDetailsFormArray['StuExamCenter'][0]['FormDisplayName']}}
                                <span *ngIf="admissionDetailsFormArray['StuExamCenter'][0]['FormRequired']">*</span>
                            </mat-label>
                            <mat-select formControlName="StuExamCenter" #select104 placeholder="Select"
                                class="colorblack">
                                <mat-option>Select</mat-option>
                                <mat-option value="1">Examination Center 1</mat-option>
                                <mat-option value="2">Examination Center 2</mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="admissionDetailsForm.controls['StuExamCenter'].touched && admissionDetailsForm.controls['StuExamCenter'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-sm-12">
                    <h6 class="mb-1 redCol"><b>
                            Note : Please fill valid qualification details.</b></h6>

                    <h6 *ngIf="showtxt" class="mb-1 reddd"><b>
                            For the selected college and course, admissions are not open</b></h6>
                    <h6 *ngIf="notOpen" class="mb-1 reddd"><b>
                            For the selected college and course, admissions will open from {{FromDate | date:'mediumDate' }}</b></h6>
                    <h6 *ngIf="AdmClosed" class="mb-1 reddd"><b>
                            For the selected college and course, admissions are closed on {{ToDate | date:'mediumDate' }}</b></h6>
                </div>
                <div class="col-sm-12">
                    <div class="row">
                        <div class="flex-container">
                            <div *ngIf="Subs" class="example-card2">
                                <div class="card-container" style="display: flex; flex-direction: row;">
                                    <mat-card>
                                        <h5>Subjects</h5>
                                        <mat-card-content>
                                            <div *ngFor="let item of Subjects; let i = index">
                                                <mat-checkbox [disabled]="(updateButton && disabled) || Sub[i] === ' '"
                                                    [checked]="shouldCheckItemForSubject(AllSub[i]) || Sub[i] === ' '"
                                                    (change)="onCheckboxChanged($event,AllSub[i])">{{item}} -
                                                    {{SubjectName[i]}}
                                                    <b *ngIf="Sub[i] !== ' '">
                                                        (Option : {{Sub[i]}})
                                                    </b>
                                                </mat-checkbox>
                                            </div>
                                        </mat-card-content>
                                    </mat-card>
                                </div>
                            </div>
                            <div *ngIf="OptSub">
                                <div class="card-container" style="display: flex; flex-direction: row;">
                                    <mat-card *ngFor="let group of GroupData" class="example-card2">
                                        <mat-checkbox [disabled]="(updateButton && disabled) || group.EsOpCode === ' '"
                                            [checked]="shouldCheckItemForGroup(group) || group.EsOpCode === ' '"
                                            (change)="onCheckboxChanged($event,group)">
                                            <h5>{{ group.EsCode }} - {{ group.EsName }}
                                                <b *ngIf="group.EsOpCode !== ' '">
                                                    (Option : {{group.EsOpCode}})
                                                </b>
                                            </h5>
                                        </mat-checkbox>
                                         <mat-card-content>
                                            <div *ngFor="let child of group.children">
                                                <mat-checkbox [disabled]="(updateButton && disabled) || child.EsOpCode === ' '"
                                                    [checked]="shouldCheckItemForGroup(child) || child.EsOpCode === ' '"
                                                    (change)="onCheckboxChanged($event,child)">
                                                    {{ child.EsCode }} - {{child.EsName }}
                                                    <b *ngIf="child.EsOpCode !== ' '">
                                                        (Option : {{child.EsOpCode}})
                                                    </b>
                                                </mat-checkbox>
                                            </div>
                                        </mat-card-content>
                                    </mat-card>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                 </div>
                <div class="mt-4">
                    <ng-container *ngIf="getValidationErrorsKeys().length > 0; else optDataSection">
                        <div *ngFor="let errorCode of getValidationErrorsKeys()">
                            <p style="color: red;">{{ validationErrors[errorCode] }}</p>
                        </div>
                    </ng-container>

                    <ng-template #optDataSection>
                        <div class="col-sm-12" *ngFor="let opt of optData">
                            <h6 class="mb-1 redCol">
                                <b>For OptCode = {{opt.OpCode}} : Min = {{opt.OpMin}} And Max = {{opt.OpMax}}</b>
                            </h6>
                        </div>
                    </ng-template>
                </div>
                <div class="row mb-2 prpl">
                    <div class="col-sm-12">

                        <button type="button"  *ngIf="submitButton" [disabled]="disabled"
                            class="btn btn-primary btn-icon-text fr sz floatright mt-1"
                            (click)="submitAddmissionDetails()">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/images/save.gif" style="margin-right: 5px;">
                                Save
                            </span>
                        </button>
                        <button type="button" *ngIf="updateButton" [disabled]="disabled"
                            (click)="UpdateQualificationDetails()"
                            class="btn btn-primary btn-icon-text fr sz floatright mt-1">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/images/edit.gif" style="margin-right: 5px;">
                                Update
                            </span>
                        </button>
                        <button type="button" (click)="back()" class="btn btn-primary btn-icon-text floatright fr mt-1">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/images/turn-left.gif" style="margin-right: 5px;">
                                Back
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>